import React from 'react';

import Avatar from '@atlaskit/avatar/avatar';

const AvatarPresenceFocusExample = (): React.JSX.Element => {
	return <Avatar name="John Smith" presence="focus" />;
};

export default AvatarPresenceFocusExample;
